var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ini-filter"},[_c('span',{staticClass:"ini-filter__title"},[_vm._v(_vm._s(_vm.title)+" :")]),_vm._l((_vm.items),function(item){return _c('span',{staticClass:"ini-filter__item"},[_c('ini-filter-item',_vm._b({on:{"change":function($event){return _vm.updateConditions($event, item)}}},'ini-filter-item',item,false))],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }